import 'regenerator-runtime';
import React from 'react';
import { render } from 'react-dom';
import App from './application-wide/App';
import './index.less';

const root = window.document.getElementById('root');
render(<App basename={window?.baseAppConfig?.basePath} />, root);
